export function countPages(totalCount: number, first: number): number {
  return Math.ceil(totalCount / first);
}
